import { APIResponse, BaseAPI } from "./api";

export class FeatureFlagsService {
  private api: BaseAPI;

  private featureFlagsApiUrl = "api/featureFlags";

  constructor() {
    this.api = new BaseAPI();
  }
  
  async isFeatureEnabled(featureFlag: FeatureFlags): Promise<APIResponse<boolean>> {
    var url = `${this.featureFlagsApiUrl}/${featureFlag}`;
    return await this.api.get(url);
  }
}

export enum FeatureFlags {
  SymptomsUploadFiles = "SymptomsUploadFiles",
  DiagnosisResultsUiV2 = "DiagnosisResultsUiV2",
}
